<template>
  <div
    v-if="showSpinner"
    class="spinner-container">
    <sIcon
      class="my-auto mx-auto"
      color="var(--secondary__green_not_active)"
      size="58"
      spin
      type="loading"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSpinner: false
    }
  },
  methods: {
    show() {
      this.showSpinner = true
    },
    close() {
      this.showSpinner = false
    }
  }
}
</script>

<style scoped>
.spinner-container {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1024;
  height: 100%;
  right: 0;
  bottom: 0;
  background-color: hsla(0, 0%, 0%, 0.5);
}
</style>
